module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI5IDE2Ij4NCiAgPGcgaWQ9Ik9OLXNtYWxsIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzE3IC0yMDI5KSI+DQogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xMDMiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDEwMyIgd2lkdGg9IjI5IiBoZWlnaHQ9IjE2IiByeD0iOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzE3IDIwMjkpIiBmaWxsPSIjNWU1NDRhIi8+DQogICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8xNyIgZGF0YS1uYW1lPSJFbGxpcHNlIDE3IiBjeD0iNiIgY3k9IjYiIHI9IjYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzMiAyMDMxKSIgZmlsbD0iI2ZmZiIvPg0KICA8L2c+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ON-small.svg
// module id = PkT3
// module chunks = 18